import { memo } from 'react';
import cx from 'classnames';
import { useStyles } from './styles';

export const Genre = memo(({ 
  name, 
  isSelected, 
  isAvailable, 
  isLoading, 
  onClick 
}) => {
  const classes = useStyles();

  return (
    <span
      className={cx(classes.categoryText, {
        selected: isSelected,
        clickable: isAvailable && !isLoading,
        loading: isLoading,
      })}
      onClick={() => isAvailable && onClick(name)}
    >
      {name}
      {isLoading && '...'}
    </span>
  );
}); 